import React, { Component } from "react";
import { Container, Tabs, Tab, Button } from "react-bootstrap";
import { FaPlus, FaTrash, FaPen, FaFileLines, FaToggleOn, FaToggleOff, FaFileImport, FaShareFromSquare } from "react-icons/fa6";
import MenuLeftCMS from "./ct-fragmentsidemenu";
import { GetText } from "../config/helper";
import "../config/global";
import CTNA from "./ct-fragmentna";

const authKey = global.config.kindcode.training[18]+global.config.authBearerKey;
const authKey2 = global.config.kindcode.training[17]+global.config.authBearerKey;

export default class CTSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activelink:"none",
      pageShow: '10',
      keyword: '',
      data: {"ENG": [], "IDN": []},
      data_incoming: [],
      defTabIndex: "",
      usageFor: '',

    };
    this.loadData = this.loadData.bind(this);
    this.loadContentIncoming = this.loadContentIncoming.bind(this);
  }

  urladdStories(param,action,currpage) {
    window.location.href=global.config.urlCms+"/"+currpage+'/add/'+param;
  }
  urldeleteIncoming(param,valId,action,currpage) {
    var stat = false;
    stat = window.confirm("Are you sure you want to delete this data?");
    if(stat === true) {
      document.getElementById('loading-area').style.display = 'block'; 
      var urlString = global.config.urlLink+"/storiesindelete";
      var datatext ='{"docid":"'+valId+'","form_id":"delete-stories-in"}';
      var data = JSON.parse(datatext); 
      fetch(urlString, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey2,
        }, body : JSON.stringify(data)
      }).then(res => {
        if(res.status === 200) 
            return res.json() 
      }).then( resJson => {
          document.getElementById('loading-area').style.display = 'none'; 
          if(resJson.status === "200") {
            param = "incoming";
            window.location.href=global.config.urlCms+"/"+currpage+'/'+param;
          } else {
              console.log('Something happened wrong delete');
          }
      }).catch(err => {
        document.getElementById('loading-area').style.display = 'none'; 
      });
    }
  }
  urldelete(param,valId,action,currpage) {
    var stat = false;
    stat = window.confirm("Are you sure you want to delete this data?");
    if(stat === true) {
      document.getElementById('loading-area').style.display = 'block'; 
      var urlString = global.config.urlLink+"/storiesdelete";
      var datatext ='{"docid":"'+valId+'","form_id":"delete-stories"}';
      var data = JSON.parse(datatext); 
      fetch(urlString, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
      }).then(res => {
        if(res.status === 200) 
            return res.json() 
      }).then( resJson => {
          document.getElementById('loading-area').style.display = 'none'; 
          if(resJson.status === "200") {
            if(param === 'IDN') { param = "indonesia"; }
            else { param = "english"; }
            window.location.href=global.config.urlCms+"/"+currpage+'/'+param;
          } else {
              console.log('Something happened wrong delete');
          }
      }).catch(err => {
        document.getElementById('loading-area').style.display = 'none'; 
      });
    }
  }
  urlpublish(valId,nextstat,param) {
    document.getElementById('loading-area').style.display = 'block';
    var datatext ='{"stories_status":"'+nextstat+'","stories_docid":"'+valId+'","form_id":"form-publish"}';
    var urlFetch = global.config.urlLink+"/storiesedit";
    var data = JSON.parse(datatext);
    fetch(urlFetch, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
    }).then(res => {
        if(res.status === 200)
            return res.json() 
    }).then( resJson => {
        if(resJson.status === '200') {
            if(param === 'IDN') { param = "indonesia"; }
            else if(param === 'ENG') { param = "english"; }
            else { param = "incoming"; }
            window.location.href=global.config.urlCms+"/"+this.state.activelink+"/"+param;
        } else {
            console.log('Something happened wrong');
        }
        document.getElementById('loading-area').style.display = 'none'; 
       
    }).catch(err => { 
        document.getElementById('loading-area').style.display = 'none'; 
    });
  }
  urlnotokIncoming(valId,nextstat,param) {
    document.getElementById('loading-area').style.display = 'block';
    var datatext ='{"stories_status":"'+global.config.storiesinStatus[nextstat]+'","stories_docid":"'+valId+'","form_id":"form-publish"}';
    var urlFetch = global.config.urlLink+"/storiesinedit";
    var data = JSON.parse(datatext);
    fetch(urlFetch, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey2,
        }, body : JSON.stringify(data)
    }).then(res => {
        if(res.status === 200)
            return res.json() 
    }).then( resJson => {
        if(resJson.status === '200') {
            if(param === 'IDN') { param = "indonesia"; }
            else if(param === 'ENG') { param = "english"; }
            else { param = "incoming"; }
            window.location.href=global.config.urlCms+"/"+this.state.activelink+"/"+param;
        } else {
            console.log('Something happened wrong');
        }
        document.getElementById('loading-area').style.display = 'none'; 
       
    }).catch(err => { 
        document.getElementById('loading-area').style.display = 'none'; 
    });
  }
  urlViewSStories(param, id, action, activelink) {
    window.location.href=global.config.urlCms+"/"+activelink+"/"+action+"/"+id;
  }
  urlimportToSStories(param, content, action, activelink) {
    window.location.href=global.config.urlCms+"/"+activelink+"/"+action+"/"+content.docid;
  }
  loadContentIncoming = (keyword,pageshow) => {
    return new Promise((resolve) => {
      var datatext ='{"keyword":"'+keyword+'","pageShow":"'+pageshow+'"}';
      var data = JSON.parse(datatext); 
      fetch(global.config.urlLink+"/storiesinlist", {
          method: 'POST',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Authorization': authKey2,
          }, body : JSON.stringify(data)
      }).then(response => {
          if(response.status === 200) {
              return response.json()
          } else {
              console.log('Something happened wrong');
          }
      }).then(resJson => {
          var resultList = resJson.values.sort((a, b) => a.content.createDate._seconds < b.content.createDate._seconds);
          resolve(resultList)
      }).catch(err => {
          resolve({"status": "500"});
          
      });
    });
  }
  loadContent = (keyword,pageshow) => {
    return new Promise((resolve) => {
      var datatext ='{"keyword":"'+keyword+'","pageShow":"'+pageshow+'"}';
      var data = JSON.parse(datatext); 
      fetch(global.config.urlLink+"/storieslist", {
          method: 'POST',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Authorization': authKey,
          }, body : JSON.stringify(data)
      }).then(response => {
          if(response.status === 200) {
              return response.json()
          } else {
              console.log('Something happened wrong');
          }
      }).then(resJson => {
          var resultList = resJson.values.sort((a, b) => b.content.storiesSortNumber < a.content.storiesSortNumber);
          var resultID = resultList.filter((list) =>  {
            return list.content.storiesLanguage === "Indonesian";
          });
          var resultEN = resultList.filter((list2) =>  {
            return list2.content.storiesLanguage === "English"; 
          });
          
          resolve({
            "ENG": resultEN,
            "IDN": resultID
          })
      }).catch(err => {
          resolve({"status": "500"});
          
      });
    });
  }

  async loadData () {
    var [result, result2] = await Promise.all([this.loadContent(this.state.keyword,this.state.pageShow), this.loadContentIncoming(this.state.keyword,this.state.pageShow)]);
    this.setState({
            data: result,
            data_incoming: result2
        })
  }

  componentDidMount() {
    var urlpath = window.location.pathname;
    if(urlpath.substring(urlpath.length-1,urlpath.length) === "/") {
      urlpath = urlpath.substring(0,urlpath.length-1);
    }
    var arrUrl = urlpath.split("/");
    
    var tabKey="", tabKey2="";
    if(arrUrl.length===3 && arrUrl[arrUrl.length-1] !== "") {
      tabKey = arrUrl[arrUrl.length-1];
      tabKey2 = arrUrl[arrUrl.length];
    } else if(arrUrl.length===4 && arrUrl[arrUrl.length-1] !== "") {
        tabKey = arrUrl[arrUrl.length-2];
        tabKey2 = arrUrl[arrUrl.length-1];
    }
    var usageFor = 'incoming'
    var defindex = "tab-1";
    if(tabKey2 !== undefined && tabKey2 !== "") { 
      if(tabKey2.toLowerCase() === "indonesia") {
        defindex = "tab-3"; usageFor = "indonesia"; 
      } else if(tabKey2.toLowerCase() === "english") {
        defindex = "tab-2"; usageFor = "english"; 
      } 
    }

    this.setState({
      activelink: tabKey,
      defTabIndex: defindex,
      usageFor: usageFor
    });
    this.loadData();
  }

  contentTabs(param) {
    var stLabel = ""; 
    var sstoriesList = [];
    
    if(param === "INC") {
      var statedata2 = [];
      stLabel = "Incoming Stories"; 
      statedata2 = this.state.data_incoming;    
      
      if(statedata2.length > 0) {
        for(var ls2=0; ls2 < statedata2.length; ls2++) {
            var retResult2 = statedata2[ls2];
            var viewURL2 = global.config.urlCms+"/"+this.state.activelink+"/viewin/"+retResult2.docid;
            sstoriesList.push(<tr key={retResult2.docid}>
                <th scope="row-field" className="text-center">{ls2+1}</th>
                <td>
                  {retResult2.content.storiesName}<br/>
                  {retResult2.content.storiesEmail}<br/><br/>
                  Type : {retResult2.content.storiesType}<br/>
                </td>
                <td>{retResult2.content.storiesMessage}</td>
                {/* <td>{parse(ReplaceOutputTextHTML(retResult.content.faqCourseQuestion))}</td>
                <td>{parse(ReplaceOutputTextHTML(retResult.content.faqCourseAnswer))}</td> */}
                <td>
                    <a href={viewURL2}><FaFileLines className="styleicons" aria-label="view" /></a>
                    
                    {
                      retResult2.content.storiesId !== undefined && retResult2.content.storiesId !== ""? 
                      <>
                        <FaShareFromSquare className="styleicons" aria-label="view to success stories" onClick={this.urlViewSStories.bind(this, param, retResult2.content.storiesId, 'view', this.state.activelink)} />
                      </>
                      : 
                      retResult2.content.status === global.config.storiesinStatus[0]? 
                      <>
                        <FaFileImport className="styleicons" aria-label="add to success stories" onClick={this.urlimportToSStories.bind(this, param, retResult2, 'addin', this.state.activelink)} />
                        <FaTrash className="styleicons" aria-label="delete" onClick={this.urlnotokIncoming.bind(this, retResult2.docid, 2, param)} />
                      </>
                      : <></>
                    }
                    {/* {iconPub} */}
                    {/* <FaTrash className="styleicons" aria-label="delete" onClick={this.urldeleteIncoming.bind(this, param, retResult2.docid, 'Delete', this.state.activelink)} /> */}
                </td>
              </tr>)
          }
      } else {
        sstoriesList.push(<tr key={param+"1"}>
              <th scope="row"></th>
              <td></td>
              <td className="d-flex p-3">- no data -</td>
              <td></td>
            </tr>)
      }

    } else {
      var statedata = [];
      if(param === 'IDN') { 
        stLabel = "Indonesia Version"; 
        statedata = this.state.data[param];
      } else if(param === 'ENG') { 
        stLabel = "English Version"; 
        statedata = this.state.data[param];
      }

      if(statedata.length > 0) {
        for(var ls=0; ls < statedata.length; ls++) {
            var retResult = statedata[ls];
            var editURL = global.config.urlCms+"/"+this.state.activelink+"/edit/"+retResult.docid;
            var viewURL = global.config.urlCms+"/"+this.state.activelink+"/view/"+retResult.docid;
            var iconPub = <FaToggleOff style={{color:"#999999"}} className="styleicons" onClick={this.urlpublish.bind(this, retResult.docid, 1, param)}/>;
            if(retResult.content.status === 1 ) { iconPub =  <FaToggleOn className="styleicons" onClick={this.urlpublish.bind(this, retResult.docid, 0, param)}/> }
  
            sstoriesList.push(<tr key={retResult.docid}>
                <th scope="row-field" className="text-center">{retResult.content.storiesSortNumber}</th>
                <td>
                  {retResult.content.storiesName}<br/>
                  {retResult.content.storiesEmail}<br/><br/>
                  Type : {retResult.content.storiesType}<br/>
                </td>
                <td>{retResult.content.storiesMessage}</td>
                {/* <td>{parse(ReplaceOutputTextHTML(retResult.content.faqCourseQuestion))}</td>
                <td>{parse(ReplaceOutputTextHTML(retResult.content.faqCourseAnswer))}</td> */}
                <td>
                    <a href={editURL}><FaPen className="styleicons" aria-label="edit" /></a>
                    <a href={viewURL}><FaFileLines className="styleicons" aria-label="view" /></a>
                    {iconPub}
                    <FaTrash className="styleicons" aria-label="delete" onClick={this.urldelete.bind(this, param, retResult.docid, 'Delete', this.state.activelink)} />
                </td>
              </tr>)
          }
      } else {
        sstoriesList.push(<tr key={param+"1"}>
              <th scope="row"></th>
              <td></td>
              <td className="d-flex p-3">- no data -</td>
              <td></td>
            </tr>)
      }
    }
    

    
    

    
    
    return(<div>
              <div className="row show">
                  <div className="col-6"></div>
                  <div className="col-6 d-flex justify-content-end">
                      {/* <Button variant="secondary" size="sm" onClick={this.urladdStories.bind(this, param.toLowerCase(),'Add',this.state.activelink)}><FaPlus style={{color:"#FFFFFF", size: "20px"}} className="me-2" />Add Faq</Button> */}
                      {param === 'INC' ? <>&nbsp;</> :   
                        <Button variant="secondary" size="sm" onClick={this.urladdStories.bind(this, param.toLowerCase(), 'Add', this.state.activelink)}>
                            <FaPlus style={{ color: "#FFFFFF", size: "20px" }} className="me-2" /> Add New Success Story
                        </Button>
                      }
                  </div>
              </div>
              <div className="mt-3">
                  <table className="table">
                    <thead className="table-dark">
                      <tr key={param+"0"}>
                      <th width="50" className="text-center" scope="col">#</th>
                      <th scope="col" width="250" >Profile</th>
                      <th scope="col">Stories</th>
                      <th width="180" scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                        {sstoriesList}
                    </tbody>
                  </table>
              </div>
           </div>
    )
    
  }  

  
  render() {
    return (
      <div className="setting">
       <Container>
      {
        (localStorage.getItem("ulvl") === global.config.userLevel[0] || localStorage.getItem("ulvl") === global.config.userLevel[2])? 
        (<>
          <div className="row py-5 mb-5">
            {/* === start - body */}
              <div className="col-md-3 bg-light">
                { 
                  this.state.activelink !== "none" && 
                    <MenuLeftCMS value={{tabkey:this.state.activelink}}/>
                
                }
              </div>
              <div className="col-md-9 p-4">
                <div className="row">
                  <div className="mb-4">
                    <h3>{GetText() ? "Kisah Sukses" : "Success Story"}</h3>
                    <span className="text-muted">{GetText() ? "Daftar Kisah Sukses" : "List of Success Story"}</span>
                  </div>
                  <div className="mt-3">
                    {
                    this.state.defTabIndex !== "" && 
                      <Tabs className="nav-scroll" defaultActiveKey={this.state.defTabIndex} variant="tabs" id="tab">
                        <Tab className="pt-4" eventKey="tab-1" title="Incoming Stories" key="T1">
                          <div>
                          {this.contentTabs("INC")}
                          </div>
                        </Tab>
                        <Tab className="pt-4" eventKey="tab-2" title="English" key="T2">
                          <div>
                          {this.contentTabs("ENG")}
                          </div>
                        </Tab>
                        <Tab className="pt-4" eventKey="tab-3" title="Indonesia" key="T3">
                          {this.contentTabs("IDN")}
                        </Tab>

                      </Tabs>
                    }
                  </div>
                </div>
              </div>
            {/* === end - body */}
          </div>
          
          </>
        )
      : 
        <div><CTNA/></div>
      }
      <div id="loading-area" className="d-none loading"></div> 
      </Container>
      </div>
    );
  }
  
}
